<script setup lang="ts">
import { NidoGliderType } from '~/service/experience/world/nido/enum'

const props = defineProps<{
  gliderType: NidoGliderType
  moduleCount: number
  gliderPrice: number
}>()

const emit = defineEmits(['glider-type-changed'])

const currentType = computed({
  get(): NidoGliderType {
    return props.gliderType
  },
  set(newValue: NidoGliderType): void {
    emit('glider-type-changed', newValue)
  },
})

function getGliderPrice() {
  return props.moduleCount * props.gliderPrice
}
</script>

<template>
  <div class="flex flex-wrap gap-x-4">
    <div class="flex items-center">
      <p
        class="text-pragmatica-extended min-w-fit whitespace-nowrap text-center text-xl font-bold"
      >
        {{ $t('nido.glider.chooseType') }}
      </p>
    </div>
    <div class="flex items-center">
      <select
        v-model="currentType"
        class="col-span-2 h-fit rounded-md bg-neutral-100 px-3 py-1 ring-1 ring-neutral-500 focus:outline-none focus:ring-2 focus:ring-neutral-600"
      >
        <option v-for="type in NidoGliderType" :key="type" :value="type">
          {{ $t('nido.glider.type.' + type) }}
        </option>
      </select>
    </div>
    <template v-if="currentType !== NidoGliderType.NONE">
      <img
        class="h-24 w-24"
        :src="'/png/' + currentType + '.png'"
        :alt="currentType"
      />
      <div class="flex w-full items-center">
        <div class="flex w-full">
          <div>{{ moduleCount }}x</div>
          <span class="mx-4 mb-2 w-full border-b border-dotted border-black" />
          <OrderSummaryPrice
            class="text-pragmatica-extended min-w-fit text-xl font-bold"
            :price="getGliderPrice()"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss"></style>
